<template>
  <div class="preview-container">
    <div class="preview-area size-A4" ref="iframeParent">
      <!-- 插入iframe -->
    </div>
    <div class="footer">
      <el-button @click="doPrint" type="primary">打印</el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, inject } from 'vue';
import tpl from './templates';

export default {
  name: 'print',
  props: {
    type: {
      type: String,
      default: 'A4',
    },
    data: {
      type: [Object, Array],
      default() {
        return {};
      },
    },
    template: [String],
  },
  setup(props) {
    const iframeParent = ref(null);

    const app = inject('app');
    let instance = null;
    onMounted(() => {
      instance = app.buildPrint({
        source: tpl[props.template],
        data: props.data,
      });
      instance.preview(iframeParent.value);
    });

    return {
      iframeParent,
      doPrint() {
        instance.print();
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.preview-container {
  padding: 20px;
  .preview-area {
    background: #fff;
    margin: 0 auto;
    text-align: center;
    height: 520px;
    width:1082px;
    // &.size-A4 {
    //   width: 740px;
    // }
    // &.size-58mm {
    //   width: 360px;
    // }
    // &.size-76mm {
    //   width: 460px;
    // }
  }
  .footer {
    text-align: right;
  }
}
</style>
